var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcnCancelCross = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 1 10 9",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.07422 1.24609L5.82031 4.5L9.07422 7.75391L8.25391 8.57422L5 5.32031L1.74609 8.57422L0.925781 7.75391L4.17969 4.5L0.925781 1.24609L1.74609 0.425781L5 3.67969L8.25391 0.425781L9.07422 1.24609Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcnCancelCross, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icn-cancel-cross.12e94f24.svg";
export { ForwardRef as ReactComponent };